<template>
  <el-autocomplete
    ref="autocomplete"
    v-scrollLoad="selectLoadMore"
    v-loading="loading"
    v-model.trim="params.keyWords"
    placeholder="请输入商户ID/商户名称"
    :fetch-suggestions="querySearchAsync"
    value-key="shopName"
    @select="handleSelect"
    @input="handleInput"
    style="width: 400px"
  >
    <template slot-scope="{ item }">
      <span style="margin-right: 10px">{{ item.shopCode }}</span>
      <span>{{ item.shopName }}</span>
    </template>
  </el-autocomplete>
</template>
<script>
import { queryShopManageList } from "@/api/businessManage";
import {
  getRecommendShopList,
  addRecommendShop,
  updateRecommendShop,
  deleteRecommendShop,
} from "@/api/recommendationHome";

export default {
  data() {
    return {
      params: {
        name: "",
        shopTypeId: "",
        shopBusinessStatus: "",
        shopType: "",
        certifyStatus: "",
        keyWords: "",
        size: 10,
        current: 1,
      },
      pageTotal: 0,
      loading: false,
    };
  },
  directives: {
    // 自定义指令，监听下拉框的滚动，滚动到底部就加载下一页
    scrollLoad: {
      bind(el, binding, vnode) {
        let wrapDom = el.querySelector(".el-autocomplete-suggestion__wrap");
        let listDom = el.querySelector(
          ".el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list"
        );
        wrapDom.addEventListener(
          "scroll",
          (e) => {
            // 注意load的使用，节流
            let condition =
              wrapDom.offsetHeight +
              wrapDom.scrollTop +
              10 -
              listDom.offsetHeight;
            if (condition > 0 && !vnode.context.loading) {
              //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
              binding.value();
            }
          },
          false
        );
      },
    },
  },
  methods: {
    querySearchAsync(queryString, cb) {
      this.loading = true;
      queryShopManageList(this.params)
        .then((res) => {
          const { records, total } = res.data;
          cb(records);
          this.pageTotal = total || 0;
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    handleSelect(row) {
      this.$emit("handleSelect", row);
    },
    handleInput() {
      if (!this.shopName) {
        this.$emit("handleSelect", {});
      }
      this.params.current = 1;
    },
    async selectLoadMore() {
      if (
        Number(this.pageTotal) <=
        this.$refs["autocomplete"].$data.suggestions.length
      ) {
        return;
      }
      this.params.current++;
      this.loading = true;
      queryShopManageList(this.params)
        .then((res) => {
          this.loading = false;
          const { records, total } = res.data;
          this.$refs["autocomplete"].$data.suggestions =
            this.$refs["autocomplete"].$data.suggestions.concat(records);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>
